import { gql } from '@apollo/client';

export const GENERATE_PICKING_LIST_PDF = gql`
  query GeneratePickingListPdf($orderIds: [Int!]!) {
    generatePickingListPdf(order_ids: $orderIds) {
      content
      filename
      message
      mime_type
      success
    }
  }
`;
